import React from 'react'
import Image from 'next/image'

import {CTAButton} from './CTAButton'

export const Hero = () => {
  return (
    <section className='AIReadiness__hero'>
      <Image
        alt='AI Readiness'
        src='/images/ai/readiness/hero.jpg'
        layout='fill'
        objectFit='cover'
        className='AIReadiness__hero__img'
      />

      <div className='container'>
        <div className='AIReadiness__hero__content'>
          <h1>AI Readiness Assessment</h1>
          <p>
            องค์กรคุณพร้อมสำหรับ AI หรือยัง ? ประเมินความพร้อมขององค์กรกับเรา
            <br />
            <strong>ฟรี เพียงกรอกแบบฟอร์ม</strong>
          </p>

          <CTAButton label='header' />
        </div>
      </div>
    </section>
  )
}
